import { render } from "./CreateTeamForm.vue?vue&type=template&id=ca40f4d4"
import script from "./CreateTeamForm.vue?vue&type=script&lang=js"
export * from "./CreateTeamForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__